import { render, staticRenderFns } from "./StateComments.vue?vue&type=template&id=4396d5c2&scoped=true&lang=html&"
import script from "./StateComments.vue?vue&type=script&lang=coffee&"
export * from "./StateComments.vue?vue&type=script&lang=coffee&"
import style0 from "./StateComments.vue?vue&type=style&index=0&id=4396d5c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4396d5c2",
  null
  
)

component.options.__file = "StateComments.vue"
export default component.exports